import styled, {
  css,
  FlattenSimpleInterpolation,
  keyframes,
} from 'styled-components/macro';
import { BackgroundType, SizeType } from './scrollable-modal.types';
import { DS_COLORS } from 'styles';
import { hexToRGB } from 'utils';

const sizeStyles: Record<SizeType, FlattenSimpleInterpolation> = {
  s: css`
    width: 450px;
  `,
  m: css`
    width: 650px;
  `,
  l: css`
    width: 1024px;
  `,
  xl: css`
    width: 1500px;
  `,
};

const backgroundStyles: Record<BackgroundType, FlattenSimpleInterpolation> = {
  white: css`
    background-color: ${DS_COLORS.white};
  `,
  gray: css`
    background-color: #f8f9fa;
  `,
};

const fadeIn = keyframes`
  from {
      opacity: 0;
      transform: translateY(-8px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
`;

export const Fade = styled.div`
  ${({ theme }) => css`
    position: fixed;
    z-index: 999;
    left: 0;
    top: 0;
    width: 100vw;
    height: 100vh;
    max-height: 100vh;
    background: ${hexToRGB(theme.colors.black, 0.5)};
    transition-duration: ${theme.tokens.animation.duration.base};
  `};
`;

export const ModalWrapper = styled.div`
  box-sizing: border-box;
  padding: 120px 24px 0 56px;
  position: fixed;
  z-index: 999;
  inset: 0;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  column-gap: 8px;
  width: 100vw;
  height: 100vh;
  overflow-y: scroll;
  animation-name: ${fadeIn};
  animation-duration: ${(props) => props.theme.tokens.animation.duration.base};
  animation-timing-function: ${(props) =>
    props.theme.tokens.animation.easing.standard};
`;

export const ModalContentWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: stretch;
  width: fit-content;
  max-width: 100%;
`;

export const ModalContainer = styled.div<{
  padding: string | number;
  size: keyof typeof sizeStyles;
  background: keyof typeof backgroundStyles;
  minHeight?: number;
}>`
  ${({ size }) => sizeStyles[size]};
  ${({ background }) => backgroundStyles[background]};

  box-sizing: border-box;
  padding: ${({ padding }) =>
    typeof padding === 'string' ? padding : `${padding}px`};
  margin-bottom: 120px;
  display: flex;
  flex-direction: column;
  z-index: 1000;
  min-height: ${({ minHeight }) => (minHeight ? `${minHeight}px` : 'auto')};
  height: fit-content;
  border-radius: 16px;
  box-shadow: 0 8px 8px 0 rgba(7, 43, 114, 0.04),
    0 12px 28px 0 rgba(0, 32, 51, 0.12);
`;

export const NavigationWrapper = styled.div`
  position: relative;
  margin-bottom: 120px;
  display: flex;
  flex-direction: column;
  row-gap: 8px;
`;

export const IconsWrapper = styled.div`
  position: sticky;
  top: -80px;
  display: flex;
  flex-direction: column;
  gap: 64px;

  & .svg-viewer {
    width: 32px;
    height: 32px;
  }
`;

export const ArrowsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const Arrow = styled.div<{ $isShown: boolean }>`
  transform: scale(${(props) => (props.$isShown ? 1 : 0)});
  transition-duration: 200ms;
`;
